import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';


export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="container nav__inner">
        <Link to="/" className="nav__logo">
          Hormone<em>ly</em>
        </Link>

        <div className={`nav__links ${menuOpen ? 'nav__links--open' : ''}`}>
          <Link to="/women" className="nav__link">Women</Link>
          <Link to="/men" className="nav__link">Men</Link>
          <Link to="/symptoms" className="nav__link">Symptoms</Link>
          <Link to="/blood-tests" className="nav__link">Blood Tests</Link>
          <Link to="/stacks" className="nav__link">Stacks</Link>
          <Link to="/symptoms" className="btn-primary nav__cta">Check your symptoms</Link>
        </div>

        <button
          className="nav__burger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span className={`burger ${menuOpen ? 'burger--open' : ''}`}></span>
        </button>
      </div>
    </nav>
  );
}
